module.exports = __webpack_public_path__ + "img/people-dress.0bfd9c38.svg";